import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
import addfooter from "./components/addfooter";
export default {
  name: "clauseList",
  mixins: [loadMoreList, serchSelect],
  components: {
    addfooter: addfooter
  },
  data: function data() {
    return {
      pagingReqFn: "payConfigurationFooterList",
      pagingReqValue: "",
      content: '',
      drawer: false
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    del: function del(data) {
      var _this = this;

      var ids = data.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'payConfigurationFooterDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this.getList();
      });
    },
    consynopsistentView: function consynopsistentView(row) {
      this.content = this.$utils.textRepl(row.data);
      this.drawer = true;
    }
  }
};